<script setup>
import {
  computed,
  toRefs,
} from 'vue';

const props = defineProps({
  emphasizeType: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
});

const {
  title,
  subTitle,
} = toRefs(props);

// (1) Title: 본문의 내용 중, 고객에게 강조하여 표현할 내용
//   a. 안드로이드: 최대 2줄 23자(24자부터 말줄임 처리)
//   b. iOS: 최대 2줄 27자(28자부터 말줄임 처리)
const mainTitleDisplay = computed(() => {
  let text = title.value || '';

  if (text.endsWith('#{ }')) {
    text = text.slice(0, text.length - 4);
  }

  const { length } = text;

  if (length > 23) {
    return `${text.slice(0, 23)}...`;
  }

  return text;
});

const emphasisMainTitleThrough = computed(() => (title.value || '').endsWith('#{ }'));

// (2) Subtitle: Title에 어떤 내용이 들어가는지에 대한 부연 설명
//   a. 안드로이드: 최대 18자(19자부터 말줄임 처리)
//   b. iOS: 최대 21자(22자부터 말줄임 처리)
const subTitleDisplay = computed(() => {
  const text = subTitle.value || '';
  const { length } = text;

  if (length > 18) {
    return `${text.slice(0, 18)}...`;
  }

  return text;
});

</script>
<template>
  <div
    class="preview-message__inner-tit"
    :class="{ 'd-none': emphasizeType !== 'TEXT' }"
  >
    <div class="preview-message__inner-tit-sub">
      {{ subTitleDisplay }}
    </div>
    <div
      class="preview-message__inner-tit-main"
      :class="{ 'line-through': emphasisMainTitleThrough }"
    >
      {{ mainTitleDisplay }}
    </div>
  </div>
</template>
<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
